<template lang="pug">
.d-flex.align-center.py-16.px-2.px-sm-8.px-md-16
  v-container(fluid)
    v-row
      v-col
        v-row(justify="center" align="center")
          v-col.text-md-center(cols="auto")
            h3.mx-2.mb-6.mb-md-12.ibm.text-h4.text-md-h3.grey--text.text--darken-4 Por que escolher o Erudio?
        v-row(justify="center" align="start")
          v-col(v-for="item in items" cols=12 :key="item.title" sm=6 md=3)
            v-img.mb-5(
              :src="item.image"
              contain
              transition="scroll-from-bottom-normal"
              min-height=190
            )
            h6.text-sm-center.mb-2.ibm.text-h6.primary--text {{ item.title }}
            .text-sm-center.mb-10.mb-sm-0.ibm.text-body-1.black--text {{ item.description }}
        v-row(justify="center" align="center")
          v-col.text-md-center(cols=12 sm="auto")
            v-btn.mt-6.mt-sm-16.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="primary"
              depressed
              :block="$vuetify.breakpoint.smAndDown"
              height=56
              @click="$goTo({ path: '/planos', target: '#plansTable' })"
            ) Conhecer mais vantagens
</template>

<script>
export default {
  components: {},
  data() {
    return {
      items: [
        {
          image: require('../../assets/illustrations/erudio_personalizacao.svg'),
          title: 'Interface personalizada',
          description:
            'Para seus colaboradores, é como estar em um sistema da empresa.'
        },
        {
          image: require('../../assets/illustrations/erudio_dinheiro.svg'),
          title: 'Pague o que usar',
          description: 'Planos do tamanho da sua necessidade!'
        },
        {
          image: require('../../assets/illustrations/erudio_certificate_enterprise.svg'),
          title: 'Valide o aprendizado',
          description:
            'Valide a formação dos seus colaboradores com a submissão de projetos.'
        },
        {
          image: require('../../assets/illustrations/erudio_engaging.svg'),
          title: 'Mais engajamento',
          description: 'Recursos exclusivos para manter seu time motivado.'
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped></style>
